import Grid from "@components/Grid/Grid";
import RenderComponents from "@utilities/renderComponents";
import Components from "../../__Components__/Components";

export interface CampaignLandingPageProps {
  headerBanner?: any;
  bodyContent?: any;
}

export const CampaignLandingPage = (props: {
  content: CampaignLandingPageProps;
}) => {
  const { content } = props;
  const { bodyContent, headerBanner } = content;

  return (
    <Grid row>
      <Grid column sm={12}>
        {headerBanner &&
          Components(
            {
              component: headerBanner.component,
              uid: headerBanner.uid,
              ...headerBanner.fields,
            },
            headerBanner.fields
          )}

        {RenderComponents(bodyContent)}
      </Grid>
    </Grid>
  );
};

export default CampaignLandingPage;
